import React from 'react'
import './Tree.css'
import tree from '../../img/tree.png'

const Tree = (props) => {
  return (
    <section id="tree-section" className="content-section tree-section">

      <div className="way-up tree-text">
        <h1 className="text-uppercase">But the way Up</h1>
        <h3 className="text-uppercase">Sometimes Requires</h3>
      </div>

      <h1 id="digging-deep" className="digging-deep tree-text" >Digging Deep</h1>

      <img src={tree} className="tree-image" alt="tree"/>
    </section>
  );
}

export default Tree



/** WEBPACK FOOTER **
 ** ./src/components/home/Tree.js
 **/